import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, object=auth
  const [token, setToken] = useState(localStorage.getItem("carivisor_token"));

  useEffect(() => {
    let active = true;
    async function check() {
      if (!token) {
        if (active) setUser(false);
        return;
      }
      try {
        const { data } = await api.get("/auth/me");
        if (active) setUser(data);
      } catch {
        localStorage.removeItem("carivisor_token");
        if (active) {
          setToken(null);
          setUser(false);
        }
      }
    }
    check();
    return () => {
      active = false;
    };
  }, [token]);

  const persist = (data) => {
    localStorage.setItem("carivisor_token", data.access_token);
    setToken(data.access_token);
    setUser(data.user);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    persist(data);
    return data.user;
  };

  const adminLogin = async (email, password) => {
    const { data } = await api.post("/auth/admin-login", { email, password });
    persist(data);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    persist(data);
    return data.user;
  };

  const applySession = (data) => {
    persist(data);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("carivisor_token");
    setToken(null);
    setUser(false);
  };

  const refreshUser = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      return null;
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, adminLogin, register, applySession, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
